import EmptyStatesPreview from '../content/EmptyStatesPreview'
import { HiPlus } from 'react-icons/hi'
import { LinkButton } from '@eggplant/pattern-library'
import {
  LinkToAddSut,
  useSpaceAccess
} from '@eggplant/routing'
import { LinkToSutsEmptyStateDoc } from '../links'
import { Path } from '@eggplant/pattern-library/src/lib/components/Artwork/Artwork'

const description = 'You need connections to systems under test (SUTs) to execute your tests.'

const renderButton = (isAdmin: boolean) => isAdmin &&
  <LinkButton variant='primary'>
    <LinkToAddSut>
      <HiPlus
        aria-hidden
        size='19.2px'
      /> New SUT
    </LinkToAddSut>
  </LinkButton>

const SUTsIntro = () => {
  const [isAdmin] = useSpaceAccess(['dai:admin'])

  return (
    <div className='grid h-full justify-center'>
      <div className='grid w-[36em]'>
        <EmptyStatesPreview
          action={renderButton(isAdmin)}
          description={description}
          icon={<Path />}
          renderLink={<LinkToSutsEmptyStateDoc />}
          title='SUTs'
        />
      </div>
    </div>
  )
}

export default SUTsIntro
